import React from 'react';
import PropTypes from 'prop-types';
import MediaQueries from 'react-responsive';
import classNames from 'classnames/bind';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import OffsetBackground from 'marketing-website/components/wrappers/OffsetBackground';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck';

import generalStyles from './style/general.module.css';
import bgStyles from './style/background.module.css';

const cx = classNames.bind({ ...generalStyles, ...bgStyles });

export default function CtaIllustration({
  alt,
  bgColor,
  bgHeight,
  children,
  headingSize,
  maxWidth,
  src,
  strapline,
  title,
  titleMaxWidth,
}) {
  const detailsOffset = (100 - bgHeight) / 2;

  const wrapClasses = cx(
    'ctaIllustration',
    `bg-${bgColor}`,
    'breakPointM-bg-none'
  );

  const detailsProps = {
    className: cx('details'),
    style: { top: `${detailsOffset}%` },
  };

  return (
    <div className={wrapClasses}>
      <OffsetBackground backgroundColor={bgColor} height={bgHeight}>
        <PageWrap size="l">
          <Grid columns={12} size="none">
            <GridItem columnSpan={12} columnSpanM={6}>
              <div className={cx('detailsContainer')}>
                <div {...detailsProps}>
                  <MaxWidth value={titleMaxWidth || '100%'}>
                    <Spacing
                      type="margin"
                      size="l"
                      sizeM="0"
                      position="topBottom"
                    >
                      <Heading
                        color="white"
                        tag="h2"
                        size={headingSize}
                        weight="semibold"
                      >
                        {title}
                      </Heading>
                      {strapline && (
                        <Spacing type="margin" size="m" position="topBottom">
                          <Paragraph color="white">{strapline}</Paragraph>
                        </Spacing>
                      )}
                      <div className={cx({ 'marginTop-l': !strapline })}>
                        {children}
                      </div>
                    </Spacing>
                  </MaxWidth>
                  <MediaQueries maxWidth={770}>
                    {src && (
                      <Image
                        alt={alt}
                        block
                        hasShadow={false}
                        maxWidth={maxWidth}
                        src={src}
                      />
                    )}
                  </MediaQueries>
                </div>
              </div>
            </GridItem>
            <GridItem columnsSpan={12} columnSpanM={6} alignContent="end">
              <MediaQueries minWidth={770}>
                <div className={cx('illustration')}>
                  {src && (
                    <Image
                      alt={alt}
                      block
                      hasShadow={false}
                      maxWidth={maxWidth}
                      src={src}
                    />
                  )}
                </div>
              </MediaQueries>
            </GridItem>
          </Grid>
        </PageWrap>
      </OffsetBackground>
    </div>
  );
}

CtaIllustration.propTypes = {
  alt: propTypeEmptyString,
  children: PropTypes.node.isRequired,
  bgColor: PropTypes.oneOf([
    'marvel',
    'green',
    'teal',
    'yellow',
    'orange',
    'pink',
    'purple',
    'red',
  ]),
  bgHeight: PropTypes.number,
  headingSize: PropTypes.string,
  maxWidth: PropTypes.number.isRequired,
  src: PropTypes.string,
  strapline: PropTypes.string,
  title: propTypeEmptyString,
  titleMaxWidth: PropTypes.number,
};

CtaIllustration.defaultProps = {
  bgColor: 'marvel',
  bgHeight: 80,
  headingSize: 'xxxl',
};



// WEBPACK FOOTER //
// ./src/components/modules/Cta/CtaIllustration/index.js